"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Copy = Copy;
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const Css_1 = require("../Css");
function Copy(props) {
    return ((0, jsx_runtime_1.jsx)("div", { css: {
            ...Css_1.Css.sm.gray700.mt2.mb3.wPx(480).$,
            "& > p": Css_1.Css.my2.$,
        }, children: props.children }));
}
